import { render, staticRenderFns } from "./ImportTariffs.vue?vue&type=template&id=2970d37e&"
import script from "./ImportTariffs.vue?vue&type=script&lang=ts&"
export * from "./ImportTariffs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports